import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function CreateNewWithdrawal() {
  const [studentName, setStudentName] = useState('');
  const [classroom, setClassroom] = useState('Cubs');
  const [notice, setNotice] = useState('30 Day Notice');
  const [reason, setReason] = useState('Changing Preschools');
  const [withdrawalDate, setWithdrawalDate] = useState(new Date());
  const [notes, setNotes] = useState('');

  const classrooms = ['Cubs', 'Teddies', 'Koalas', 'Pandas', 'Preschool', 'Pre-K', 'Kindergarten'];
  const noticeTypes = ['30 Day Notice', 'Waived', 'Other Notice', 'No Notice'];
  const reasonTypes = ['Changing Preschools', 'Moving', 'Financial', 'Going to Private School', 'Other', 'Issue With School'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'studentWithdrawals'), {
        studentName,
        classroom,
        notice,
        reason,
        withdrawalDate,
        notes
      });
      alert('Student withdrawal added successfully!');
      // Reset form
      setStudentName('');
      setClassroom('Cubs');
      setNotice('30 Day Notice');
      setReason('Changing Preschools');
      setWithdrawalDate(new Date());
      setNotes('');
    } catch (error) {
      console.error('Error adding student withdrawal: ', error);
      alert('Error adding student withdrawal. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 p-8">Create New Withdrawal</h1>
        <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 p-10">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="studentName">
              Student Name
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="studentName"
              type="text"
              placeholder="Enter student name"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="classroom">
              Classroom
            </label>
            <select
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="classroom"
              value={classroom}
              onChange={(e) => setClassroom(e.target.value)}
              required
            >
              {classrooms.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="notice">
              Notice
            </label>
            <select
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="notice"
              value={notice}
              onChange={(e) => setNotice(e.target.value)}
              required
            >
              {noticeTypes.map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="reason">
              Reason
            </label>
            <select
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
            >
              {reasonTypes.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="withdrawalDate">
              Withdrawal Date
            </label>
            <DatePicker
              selected={withdrawalDate}
              onChange={(date) => setWithdrawalDate(date)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="notes">
              Notes
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="notes"
              placeholder="Enter any additional notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            ></textarea>
          </div>
          <div className="flex items-center justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateNewWithdrawal;